import React, { useEffect, useState } from "react";
import MainComponent from "../MainComponent";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getEcosystemMappingSectionDetails } from "../../store/actions";
import keys from "../../utils/helpInfoKeys.json";
import Login from "../Login";
import SideNavHelpInfo from "../../utils/SideNavHelpInfo";
import { motion } from "motion/react";

const Ecosystemsummary = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedHelpInfoSidebar = useSelector(
    (state) => state.selectedHelpInfoSidebar
  );
  const [communityData, setCommunityData] = useState([]);
  const fetchEcosystemMappingSectionData = useSelector(
    (state) => state.fetchEcosystemMappingSectionData
  );
  useEffect(() => {
    if (localStorage.getItem("bi_id")) {
      dispatch(
        getEcosystemMappingSectionDetails(localStorage.getItem("bi_id"))
      );
    }
  }, []);
  useEffect(() => {
    if (
      fetchEcosystemMappingSectionData &&
      fetchEcosystemMappingSectionData.sections.length > 0
    ) {
      setCommunityData(fetchEcosystemMappingSectionData.sections);
    }
  }, [fetchEcosystemMappingSectionData]);

  const handleBack = () => {
    navigate("/dashboard", { replace: true });
  };

  const handleClick = () => {
    navigate("/executionplansummary", { replace: true });
  };
  const content = (
    <>
      <motion.div
        initial={{ y: "100%" }}
        animate={{ y: 0 }}
        transition={{ duration: 0.8, ease: "easeInOut" }}
      >
        {selectedHelpInfoSidebar && <SideNavHelpInfo />}
        <div className="ecosystem-reports-container">
          {communityData.map((section) => (
            <div key={section.id} className="ecosystem-reports-section">
              <h2 className="ecosystem-reports-section-title" style={{fontWeight: "var(--heading-font-weight)"}} >
                {section.name}
              </h2>
              <table className="ecosystem-reports-table">
                <tbody>
                  {section.sub_section.map((subSection) => (
                    <React.Fragment key={subSection.id}>
                      <tr className="ecosystem-reports-sub-section-row">
                        <td
                          className="ecosystem-reports-sub-section"
                          colSpan={2}
                          style={{fontWeight: "var(--heading-font-weight)"}}
                        >
                          {subSection.name}
                        </td>
                      </tr>
                      {subSection.childrens.length > 0 ? (
                        subSection.childrens.map((child) => (
                          <tr
                            key={child.id}
                            className="ecosystem-reports-child-row"
                          >
                            <td className="ecosystem-reports-child">
                              {child.name}
                            </td>
                            <td
                              style={{ textAlign: "left" }}
                              className="ecosystem-reports-sub-children"
                            >
                              {child.childrens.length > 0 ? (
                                child.childrens.map((subChild) => (
                                  <div
                                    key={subChild.id}
                                    className="ecosystem-reports-sub-child"
                                  >
                                    {subChild.name}
                                  </div>
                                ))
                              ) : (
                                <span className="ecosystem-reports-no-sub-child">
                                  No Data
                                </span>
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan={2}
                            className="ecosystem-reports-no-children"
                          >
                            No Data
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      </motion.div>
    </>
  );

  if (!localStorage.getItem("authenticated")) {
    return (
      <div>
        <Login />
      </div>
    );
  } else {
    return (
      <MainComponent
        maincontent={content}
        showSelector={true}
        showButtons={true}
        handleNext={handleClick}
        handleBackButton={handleBack}
        breadcrumbParent={"Reports"}
        breadcrumbChild={"Ecosystem Summary"}
        documentName={"Ecosystem Summary"}
        helpKey={keys["Ecosystem Summary"].Name}
        image={"none"}
      />
    );
  }
};

export default Ecosystemsummary;
